var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Hotspot',{attrs:{"type":_vm.type,"bg-color":_vm.metaStyles.backgroundColor,"data":_vm.data},nativeOn:{"click":function($event){return _vm.handleClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }